/**
 * 指挥页设备列表拉取：触发条件与成功后副作用契约（纯函数，便于单测）
 */

/** 设置与轨迹模式都就绪后，是否安排首次/就绪拉取 */
export function shouldFetchDevicesWhenSettingsReady({
  settingsLoaded,
  trackModeApplied
} = {}) {
  return Boolean(settingsLoaded && trackModeApplied);
}

/**
 * 轨迹/显示设置参数变化时是否重新拉取队员列表。
 * 水合完成后即跟随「显示设置」时间窗；不要求已点「应用」。
 * （「应用」只约束历史轨迹绘制；换帐号后改最近N天若仍要求 applied，列表会卡在旧 display_days≈在线）
 */
export function shouldFetchDevicesOnTrackModeChange({
  settingsHydrated,
  settingsLoaded
} = {}) {
  return Boolean(settingsHydrated && settingsLoaded);
}

/**
 * 设备列表拉取成功后的副作用计划。
 * 产品约束：成功后不得自动飞向队员，也不得自动开启实时轨迹绘制（改为手动「绘制轨迹」）。
 */
export function planDeviceFetchSuccessEffects() {
  return {
    shouldAutoFlyToMember: false,
    shouldAutoStartTrackDrawing: false,
    autoStartTrackDelayMs: 1000
  };
}

/** 统一安排一次延迟拉取，便于去重与测试 */
export function scheduleDashboardDeviceFetch(fetchDevices, delayMs = 0, timerImpl = setTimeout) {
  if (typeof fetchDevices !== 'function') return null;
  return timerImpl(() => {
    fetchDevices();
  }, delayMs);
}
